import { TaskSetupMFA } from '@clerk/clerk-react';

/** Clerk-native mandatory MFA enrolment for pending setup-mfa sessions. */
export default function SetupMfa() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <p className="text-sm font-semibold tracking-[0.24em] text-primary">PROVENANCE365</p>
          <h1 className="mt-3 text-2xl font-semibold text-foreground">Secure your account</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Set up a second factor before continuing to the platform.
          </p>
        </div>
        <TaskSetupMFA redirectUrlComplete="/app" />
      </div>
    </main>
  );
}
